import { Navigate, Outlet } from 'react-router-dom';
import * as globalConstants from 'src/constants/index';

interface ContentGuardProps {
  contentType: string;
  isAllowed: boolean;
  redirectPath?: string;
  children?: React.ReactNode;
}

const ContentGuard: React.FC<ContentGuardProps> = ({
  contentType,
  isAllowed,
  redirectPath = '/login',
  children,
}) => {
  if (!isAllowed) {
    if (contentType === globalConstants.CONTENT_GUARD_PAGE) {
      return (
        <Navigate
          to={redirectPath}
          replace
        />
      );
    } else if (contentType === globalConstants.CONTENT_GUARD_REACT_ELEMENT) {
      return <></>;
    }
  }
  return <>{typeof children !== 'undefined' ? children : <Outlet />}</>;
};

export default ContentGuard;
